export default "__VITE_ASSET__DaOSAAMQ__"